<div class="flex column root">
    @if (client$ | async; as client) {
        <h1>{{ client.config.data.name }}</h1>
    }
    @if (client$ | async) {
        <frog-invite-users-button></frog-invite-users-button>
    }
    <h2>Streams</h2>
    <mat-divider></mat-divider>
    @if (
        {
            streams: streams$ | async,
            activeStream: stream$ | async,
        };
        as data
    ) {
        <mat-list class="menu" role="list">
            <mat-tree [dataSource]="streamTree.dataSource" [treeControl]="streamTree.treeControl">
                <mat-tree-node
                    *matTreeNodeDef="let node"
                    matTreeNodePadding
                    (click)="viewStream(node.stream)"
                    [class.active]="node.stream.id === data.activeStream?.id"
                >
                    {{ node.name }}
                </mat-tree-node>
                <mat-tree-node
                    *matTreeNodeDef="let node; when: hasChild"
                    matTreeNodePadding
                    (click)="viewStream(node.stream)"
                    [class.active]="node.stream.id === data.activeStream?.id"
                >
                    {{ node.name }}
                </mat-tree-node>
            </mat-tree>
        </mat-list>
    }
</div>
